import * as z from "zod";

export const refreshShippingRates = {
  name: "refreshShippingRates" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({}),
};
